export default __webpack_public_path__ + "static/media/HashIcon.97b7b9cb.svg";